import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { Security, ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Security color="error" sx={{ fontSize: '4rem', mb: 2 }} />
        <Typography variant="h4" gutterBottom>
          Acceso No Autorizado
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          No tienes permisos para acceder a esta página.
        </Typography>
        
        <Button
          variant="contained"
          startIcon={<ArrowBack />}
          onClick={() => navigate(-1)}
        >
          Volver
        </Button>
      </Box>
    </Container>
  );
};

export default Unauthorized;
